import { defineMessages } from '@sevenrooms/core/locales'

export const upgradeDetailsMessages = defineMessages({
  title: {
    id: 'upgrade.details.title',
    defaultMessage: 'Upgrades',
  },
})
